import React from 'react';

import Badge from 'components/v2/Badge';

import styles from './NewToRoleBadge.module.css';

const NewToRoleBadge = () => <Badge className={styles.root}>New To Role</Badge>;

export default NewToRoleBadge;
